import { render, staticRenderFns } from "./joinin.vue?vue&type=template&id=09481666&scoped=true"
import script from "./joinin.vue?vue&type=script&lang=js"
export * from "./joinin.vue?vue&type=script&lang=js"
import style0 from "./joinin.vue?vue&type=style&index=0&id=09481666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09481666",
  null
  
)

export default component.exports